import * as type from "./type";

export const getNotificationListRequest = (data) => {
  return { type: type.GET_NOTIFICATION_LIST_REQUEST, payload: data };
};
export const getNotificationListSuccess = (data) => {
  return { type: type.GET_NOTIFICATION_LIST_SUCCESS, payload: data };
};
export const getNotificationCountRequest = () => {
  return { type: type.GET_NOTIFICATION_COUNT_REQUEST };
};
export const getNotificationCountSuccess = (data) => {
  return { type: type.GET_NOTIFICATION_COUNT_SUCCESS, payload: data };
};
export const readNotificationRequest = (data) => {
  return { type: type.READ_NOTIFICATION_REQUEST, payload: data };
};
export const readNotificationSuccess = (data) => {
  return { type: type.READ_NOTIFICATION_SUCCESS, payload: data };
};
export const clearNotifications = () => {
  return { type: type.CLEAR_NOTIFICATIONS };
};
